import { Component, input, computed, inject, output, effect, untracked } from '@angular/core';
import {TrajetDto} from '../../dto/trajet.dto';
import {RafraichissementTrajetsService} from '../../../gestion-navette/onglets-gestion-navette/trajets/services/rafraichissement-trajets.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AdaptateurEcranService} from '../../services/adaptateur-ecran.service';
import {ModeNavette} from '../../models/mode-navette.enum';
import { TrajetSelectionneService } from '../../../gestion-navette/onglets-gestion-navette/trajets/services/trajet-selectionne.service'

@Component({
	selector: 'app-affichage-liste-trajets',
	templateUrl: './affichage-liste-trajets.component.html',
	styleUrl: './affichage-liste-trajets.component.scss'
})
export class AffichageListeTrajetsComponent {
	// Inputs
	cartesDesactiveesSiTrajetPasse = input<boolean>(false);
	delaiLimiteReservationApresDepart = input<number>(0);
	enChargement = input<boolean>(false);
	messageAucunTrajet = input<string>('');
	modeAffichage = input.required<ModeNavette>();
	trajets = input.required<TrajetDto[]>();

	// Outputs
	rafraichirListe = output<void>();

	// Injections
	private adaptateurEcranService = inject(AdaptateurEcranService);
	private rafraichissementTrajetsService = inject(RafraichissementTrajetsService);
	private trajetSelectionneService = inject(TrajetSelectionneService);

	// Computed
	estAffichageMobile = computed(() => this.modeAffichage() === ModeNavette.RESERVATION && this.adaptateurEcranService.estAffichageMobile());

	/**
	 * Map des trajets par date (clé = date, valeur = liste de trajets).
	 */
	mapTrajets = computed(() => {
		const map = this.trajets().reduce((map, trajet) => {
			const date = new Date(trajet.dateDepart).toISOString().slice(0, 10);
			if (!map.has(date)) map.set(date, []);
			map.get(date)!.push(trajet);
			return map;
		}, new Map<string, TrajetDto[]>());

		return new Map(
			[...map.entries()]
				.sort(([a], [b]) => a.localeCompare(b))
				.map(([date, trajetsDuJour]) => [
					date,
					trajetsDuJour.sort((t1, t2) =>
						new Date(t1.dateDepart).getTime() - new Date(t2.dateDepart).getTime()
					)
				])
		);
	});

	constructor() {
		this.ecouterDemandesRafraichissement();
		this.ecouterChangementsTrajets();
	}

	/**
	 * Retourne toutes les dates distinctes des trajets.
	 *
	 * @returns {string[]} les dates distinctes.
	 */
	get datesTrajets(): string[] {
		return Array.from(this.mapTrajets().keys());
	}

	/**
	 * Écoute les demandes de rafraîchissement pour la liste de trajets.
	 */
	ecouterDemandesRafraichissement(): void {
		this.rafraichissementTrajetsService.declencheurRafraichissement.pipe(
			takeUntilDestroyed()
		).subscribe(() => {
			this.rafraichirListe.emit();
		});
	}

	/**
	 * Ecoute les changements de la liste de trajets et met à jour le trajet sélectionné dans le service.
	 */
	ecouterChangementsTrajets() : void {
		effect(() => {
			const trajets = this.trajets();
			untracked(() => this.trajetSelectionneService.actualiserTrajetSelectionne(trajets));
		}, { allowSignalWrites: true });
	}
}
